export const imageMap: { [key: string]: string } = {
  K: 'red_shuai',
  R: 'red_che',
  N: 'red_ma',
  C: 'red_pao',
  B: 'red_xiang',
  A: 'red_shi',
  P: 'red_bing',
  k: 'black_jiang',
  r: 'black_che',
  n: 'black_ma',
  c: 'black_pao',
  b: 'black_xiang',
  a: 'black_shi',
  p: 'black_zu',
}

export const trans = (
  fen: string,
  role = 'RED',
  width: number,
  height: number,
): [string, number, number][] => {
  let xs = (width - (width * 62) / 375) / 8 // x宽
  let ys = (height - (height * 60) / 375) / 9 // y宽
  let xp = (width * 32) / 375 - 36 // x偏移
  let yp = (width * 32) / 375 - 36 // y偏移
  let res: [string, number, number][] = []
  let transFen = fen.split(' ')[0]
  if (role !== 'RED') {
    transFen = transFen.split('').reverse().join('')
  }
  let arr = transFen.split('/')
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0, k = 0; j < arr[i].length; j++) {
      let curr = imageMap[arr[i][j]]
      if (curr) {
        res.push([curr, k * xs + xp, i * ys + yp])
        k++
      } else {
        k = k + parseInt(arr[i][j])
      }
    }
  }
  return res
}

export const useSite = (width: number, height: number, piece: number) => {
  let xs = (width - (width * 62) / 375) / 8 // x宽
  let ys = (height - (height * 64) / 375) / 9 // y宽
  let xp = (width * 32) / 375 - piece / 2 // x偏移
  let yp = (width * 34) / 375 - piece / 2 // y偏移
  return [xs, ys, xp, yp]
}

// fen 转成 一维map
export const transferFenMap = (fen: string) => {
  let res: any[] = []
  let index = 0
  let transFen = fen.split(' ')[0]
  let arr = transFen.split('/').join('').split('')
  for (let i = 0; i < arr.length; i++) {
    if (imageMap[arr[i]]) {
      res.push([arr[i], index % 9, Math.floor(index / 9), false])
      index++
    } else {
      for (let n = 0; n < Number(arr[i]); n++) {
        res.push([null, index % 9, Math.floor(index / 9), false])
        index++
      }
    }
  }
  return res
}

// 二维map 转 一维map
export const map2map = (map: any[][]) => {
  if (!map.length) return []
  let res: any[] = []
  for (let i = 0; i < 10; i++) {
    for (let j = 0; j < 9; j++) {
      res.push([map[i][j], j, i, false])
    }
  }
  return res
}

// 二维map 转成 fen
export const map2fen = (map: any[][]) => {
  if (!map.length) return ''
  let res = ''
  for (let i = 0; i < 10; i++) {
    let k = 0
    for (let j = 0; j < 9; j++) {
      if (map[i][j]) {
        if (k > 0) {
          res += k
          k = 0
        }
        res += map[i][j]
      } else {
        k++
      }
      if (j === 8) {
        if (k > 0) {
          res += k
          k = 0
        }
      }
    }
    if (i < 9) {
      res += '/'
    }
  }
  return res
}

// fen 转成 二维map
export const transferFenMap2 = (fen: string) => {
  let res: any[][] = []
  let index = 0
  let transFen = fen.split(' ')[0]
  let arr = transFen.split('/').join('').split('')
  for (let i = 0; i < arr.length; i++) {
    if (imageMap[arr[i]]) {
      if (!res[Math.floor(index / 9)]) {
        res[Math.floor(index / 9)] = []
      }
      res[Math.floor(index / 9)][index % 9] = arr[i]
      index++
    } else {
      for (let n = 0; n < Number(arr[i]); n++) {
        if (!res[Math.floor(index / 9)]) {
          res[Math.floor(index / 9)] = []
        }
        res[Math.floor(index / 9)][index % 9] = null
        index++
      }
    }
  }
  return res
}

export const initFen = 'rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR'

/**
 * 判断相邻两个fen值的棋子变动
 * @param sFen string 开始fen
 * @param eFen string 结束fen
 * @returns
 */
export type PieceChagneSite = {
  s: string | null
  sx: number
  sy: number
  e: string | null
  ex: number
  ey: number
}
export const findChangedSteps = (
  sFen: string,
  eFen: string,
): [PieceChagneSite, Piece] | [{}, {}] => {
  console.log(sFen, eFen)
  const sMap2 = transferFenMap2(sFen)
  const eMap2 = transferFenMap2(eFen)
  console.log(sMap2, eMap2)
  let pieceSite: PieceChagneSite = {
    s: null,
    sx: 0,
    sy: 0,
    e: null,
    ex: 0,
    ey: 0,
  }
  let pieceSite2: Piece = {
    // 上一步/悔棋
    s: null,
    x: 0,
    y: 0,
  }
  let count = 0 // 记录不同值，仅2个
  let changes: any[] = [] // 不同值的坐标
  for (let j = 0; j < 10; j++) {
    for (let i = 0; i < 9; i++) {
      if (sMap2[j][i] !== eMap2[j][i]) {
        changes.push([sMap2[j][i], eMap2[j][i], j, i])
        ++count
        if (count === 2) break
      }
    }
  }
  // const changes = [
  //   ['R', null, 9, 1],
  //   ['c', 'R', 2, 1],
  // ]
  console.log('changes', changes)
  if (changes.length !== 2) return [{}, {}]
  /* // 移动
  const a1 = [
    ['C', null, 7, 1],
    [null, 'C', 7, 4],
  ]
  // 移动悔棋
  const a2 = [
    [null, 'C', 7, 4],
    ['C', null, 7, 1],
  ]

  // 吃子 C吃p
  const a3 = [
    ['p', 'C', 3, 4],
    ['C', null, 7, 4],
  ]
  // 吃子 C吃p 悔棋
  const a4 = [
    ['C', 'p', 3, 4],
    [null, 'C', 7, 4],
  ]

  // 吃子 C吃p
  const a5 = [
    ['C', null, 2, 7],
    ['p', 'C', 9, 7],
  ]
  // 吃子 C吃p 悔棋
  const a6 = [
    [null, 'C', 2, 7],
    ['C', 'p', 9, 7],
  ] */

  if (changes[0][0] !== null && changes[0][0] === changes[1][1]) {
    // 走棋 / 吃子
    pieceSite = {
      s: changes[0][0],
      sx: changes[0][3],
      sy: changes[0][2],
      e: changes[1][0],
      ex: changes[1][3],
      ey: changes[1][2],
    }
    if (changes[0][1] !== null) {
      // 吃子悔棋
      pieceSite2 = {
        s: changes[0][1],
        x: changes[0][3],
        y: changes[0][2],
      }
    }
  } else if (changes[0][1] !== null && changes[0][1] === changes[1][0]) {
    // 走棋 / 吃子
    pieceSite = {
      s: changes[1][0],
      sx: changes[1][3],
      sy: changes[1][2],
      e: changes[0][0],
      ex: changes[0][3],
      ey: changes[0][2],
    }
    if (changes[1][1] !== null) {
      // 吃子悔棋
      pieceSite2 = {
        s: changes[1][1],
        x: changes[1][3],
        y: changes[1][2],
      }
    }
  }

  console.log(pieceSite, pieceSite2)
  return [pieceSite, pieceSite2]
}

type Piece = {
  s: string | null // 棋子符号
  x: number // x 坐标
  y: number // y 坐标
}
export const moveChess = (
  s: string,
  sx: number,
  sy: number,
  ex: number,
  ey: number,
  map2: any[][],
  add?: Piece,
) => {
  const _map2 = JSON.parse(JSON.stringify(map2))
  _map2[sy][sx] = null
  _map2[ey][ex] = s
  if (add) {
    _map2[add.y][add.x] = add.s
  }
  const _fen = map2fen(_map2)
  return [_fen, _map2]
}
